import React, { ReactElement } from 'react';
import { FieldProps, ErrorMessage, useFormikContext, getIn } from 'formik';
import classnames from 'classnames';
import { tile } from '@interfaces/interfaces';
import styles from './CheckboxInputGroupAccessible.module.scss';

interface iProps extends FieldProps {
  title: string;
  tileData: tile[];
  disabled?: boolean;
  displayError?: boolean;
}

const CheckboxInputGroupAccessible = ({ field, form, tileData, title, disabled = false, displayError = true }: iProps): ReactElement => {
  const { values, errors }: { values: any; errors: any } = useFormikContext();
  const hasError = getIn(errors, field.name);

  return (
    <div>
      <span>{title}</span>
      {tileData.map((tileItem) => (
        <React.Fragment key={tileItem.value}>
          <label className={styles.container} htmlFor={tileItem.value}>
            <input
              type="checkbox"
              className={classnames({
                [styles.inputError]: hasError,
              })}
              id={tileItem.value}
              name={field.name}
              value={tileItem.value}
              onKeyDown={(e) => {
                if (e.key === ' ') {
                  if (!getIn(values, field.name).includes(tileItem.value)) {
                    form.setFieldTouched(field.name);
                    form.setFieldValue(field.name, [...getIn(values, field.name), tileItem.value]);
                  } else {
                    form.setFieldTouched(field.name);
                    form.setFieldValue(
                      field.name,
                      getIn(values, field.name).filter((checkedInputs: string) => checkedInputs !== tileItem.value),
                    );
                  }
                }
              }}
              onChange={(e) => {
                if (e.target.checked) {
                  form.setFieldTouched(field.name);
                  form.setFieldValue(field.name, [...getIn(values, field.name), e.target.value]);
                } else {
                  form.setFieldTouched(field.name);
                  form.setFieldValue(
                    field.name,
                    getIn(values, field.name).filter((checkedInputs: string) => checkedInputs !== e.target.value),
                  );
                }
              }}
              checked={getIn(values, field.name).includes(tileItem.value)}
              disabled={disabled}
            />
            <span className={classnames({ [styles.tickContainer]: true, [styles.tickContainerSelected]: values[field.name].includes(tileItem.value) })} />
            <span className={styles.body}>{tileItem.body}</span>
          </label>
          <hr />
        </React.Fragment>
      ))}
      {displayError && <ErrorMessage className={styles.errorMsg} name={field.name} component="span" />}
    </div>
  );
};

export default CheckboxInputGroupAccessible;
